import React from 'react'
// import hero1 from './her0ff.jpg'
import hero1 from './currenthero.png'
import Button from '@mui/material/Button';
import { Link } from 'react-scroll';


import './HeroSection.css'


export default function HeroSection() {
  return (
    // // <div className="herosection_container">

    // <div className="col-lg-12">
    //     <div className="row">
    //         <div className="col-lg-6 d-flex align-items-center justify-content-center">
        
    //             <div className='content'>

    //             <h1 className='mb-3' style={{fontSize:"6em"}}>Let's build</h1>
    //             <h3 className='mb-5'>quality products in programming <br/> and design with my services</h3>
    //             <h4  >Your Website Deserves the Best - And That's Me,<br/> a Top-Notch Frontend Developer!</h4>

    //             <button className='mt-4 mx-4'>DOWNLOAD CV</button>
    //             <button className='mx-4'>VIEW MY WORK</button>
           
    //             </div>
     
    //         </div>
          

    //         <div className="col-lg-6 ">
    //             {/* <img src={Newhero} alt=""  /> */}
    //             <img src={hero1} className="img-fluid" alt=""  />
                
             
    //         </div>
           
        
    //     </div>
    //     </div>

  //  <div className="row"> 
  // <div className="row col-lg-12 d-flex ">
  //   <div className="col-lg-6 col-12 text-center">
  //   <div className='content'>

  //            <h1 className='mb-3' style={{fontSize:"6em"}}>Let's build</h1>
  //            <h3 className='mb-5'>quality products in programming <br/> and design with my services</h3>
  //            <h4  >Your Website Deserves the Best - And That's Me,<br/> a Top-Notch Frontend Developer!</h4>

  //            <button className='mt-4 mx-4'>DOWNLOAD CV</button>
  //            <button className='mx-4'>VIEW MY WORK</button>
       
  //           </div>
  //   </div>
  //   <div className="col-lg-6 col-12">
  //   <img src={hero1} className="image-fluid" alt=""  />
  //   </div>
  // </div>
  // <div className="container-fluid">
    <div className="col-lg-12" id='home'>

  <div className="row mx-auto">
    <div className="col-lg-6 col-md-6 col-12 text-center d-flex align-items-center ">
    <div className='content mx-auto'>

           <h1 className='mb-3 h1' style={{fontSize:"6em"}}>Let's build</h1>
           <h2 className='mb-4 p1' >quality products in programming <br/> and design with my services</h2>
            <h2 className='p2' >Your Website Deserves the Best - And That's Me,<br/> a Top-Notch Frontend Developer!</h2>
            {/* <Button variant="contained" className='mt-4 mx-4 d_btn'>DOWNLOAD CV</Button> */}
            <Button variant="contained" className='mt-4 mx-4 v_btn'>
            <Link to="contact" spy={true} smooth={true} offset={-100} duration={1000} class="" aria-current="page">Hire Me</Link>
            </Button>
            {/* <button className='mt-4 mx-4'>DOWNLOAD CV</button>
           <button className='mx-4'>VIEW MY WORK</button> */}
     
           </div>
    </div>
    <div className="col-lg-6 col-md-6 col-12 my-3">
      <img src={hero1} className="img-fluid" alt=""/>
      </div>
  </div>
  </div>
    //  </div>
  )
}
